module.exports = __webpack_public_path__ + "img/VIP-5.727a4714.png";